/**
 * Created by Mark on 03/04/2017.
 */

import React from 'react';
import ApplicationRouter from './application.router.js';
import AuthenticationStore from './store/authentication-store.js';
import {IntlProvider} from 'react-intl';
import InternationalizationService from './services/internationalization-service.js';
import InternationalizationStore from './store/internationalization-store.js';
import AuthenticationService from './services/authenticate-services.js';

import './css/material-design-iconic-font.css';
import './css/animate.min.css';
import './css/app.min.1.css';
import './css/app.min.2.css';
import './css/palette.css';
import './css/default-branding.css';
import './css/wizard.css';
import './css/muilt-select.css';
import './css/react-bootstrap-table.css';

import $ from 'jquery';


export default class Application extends React.Component {
    constructor(){
        super();
        // use this if you need local Login - i.e. have this as false on live
        /*this.isLocalLogin = false;
        if (!this.isLocalLogin){
            window.location.assign('https:\//resources.languagenut.com\/resources\/#\/LoginScreen');
        }*/
        this.state = {brandingStylePath: 'style1.css'};
        this.state = {
            locale: InternationalizationStore.determineLocaleFromBrowser(),
            translations:{}
        }
    }

    componentDidMount(){
        InternationalizationService.getTranslations(InternationalizationStore.determineLocaleFromBrowser());
        AuthenticationService.getUnixPermissions();
        $('body').on('focus', '.fg-line .form-control', function(){$(this).closest('.fg-line').addClass('fg-toggled');})

        $('body').on('blur', '.form-control', function(){

            var p = $(this).closest('.form-group, .input-group');
            var i = p.find('.form-control').val();

            if (p.hasClass('fg-float')) {
                if (i.length == 0) {
                    $(this).closest('.fg-line').removeClass('fg-toggled');
                }
            }
            else {
                $(this).closest('.fg-line').removeClass('fg-toggled');
            }
        });

    }

    componentWillMount(){

        AuthenticationStore.on("CHANGE" , () => {
            if(AuthenticationStore.isAuthenticated())
            {
                InternationalizationStore.getInterfaceTranslations(InternationalizationStore.determineLocaleFromBrowser())
            }
        });

        InternationalizationStore.on("CHANGE" , () => {

            this.setState({
                locale: InternationalizationStore.locale,
                translations: InternationalizationStore.translations
            })
        });
    }

    render() {

        function isEmpty(obj) {
            for(var prop in obj) {
                if(obj.hasOwnProperty(prop))
                    return false;
            }

            return JSON.stringify(obj) === JSON.stringify({});
        }

        if(isEmpty(this.state.translations)) return null;

            return (
                <div>
                    <link rel="stylesheet" type="text/css" href={this.state.brandingStylePath} />
                    <IntlProvider locale={'en'} messages={this.state.translations}>
                        <ApplicationRouter />
                    </IntlProvider>
                </div>
            );
        
    }
}


// WEBPACK FOOTER //
// ./src/application.js